import React from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import {  TextField } from "@material-ui/core";
import * as auth from "../../store/ducks/auth.duck";
import { Auth } from 'aws-amplify';


function Verification(props) {
  const { intl } = props;
  console.log(props);
  let history = useHistory();

  return (
    <div className="kt-login__body">
      <div className="kt-login__form">
        <div className="kt-login__title">
          <h3>
            <FormattedMessage id="AUTH.VERIFICATION.TITLE" />
          </h3>
        </div>

        <Formik
          initialValues={{
            email: "",
            code: "",
            fullname: "",
            username: "",
            password: "",
            acceptTerms: true,
            confirmPassword: ""
          }}
          validate={values => {
            const errors = {};

            if (!values.code) {
              errors.code = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
            if (!values.password) {
              errors.password = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            if (!values.confirmPassword) {
              errors.confirmPassword = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            } else if (values.password !== values.confirmPassword) {
              errors.confirmPassword =
                "La contraseña y la confirmación de la contraseña no coincide";
            }

            return errors;
          }}
          onSubmit={(values, { setStatus, setSubmitting }) => {
            setTimeout(() => {
              
                Auth.forgotPasswordSubmit(
                  props.location.state.user,  // the Cognito User Object
                  values.code,
                  values.password               // the new password
                ).then(user => {
                    // at this time the user is logged in if no MFA required
                    console.log("bien ahi")
                    //console.log(user);
                    history.push({
                      pathname: '/auth/login'
                    });
                }).catch(e => {
                  setSubmitting(false);
                  if(e.code == "InvalidParameterException"){
                    setStatus("La contraseña tiene que ser de mínimo 8 caracteres.");
                  }
                  if(e.code == "CodeMismatchException"){
                    setStatus("El código ingresado no es válido.");
                  }
                  console.log("Error en el cambio de contraseña")
                  console.log(e);
                });
             
            }, 1000);
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              {status && (
                <div role="alert" className="alert alert-danger">
                  <div className="alert-text">{status}</div>
                </div>
              )}

              <div className="form-group mb-0">
                <TextField
                  type="text"
                  margin="normal"
                  label="Código"
                  className="kt-width-full"
                  name="code"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.code}
                  helperText={touched.code && errors.code}
                  error={Boolean(touched.code && errors.code)}
                />
              </div>

              <div className="form-group mb-0">
                <TextField
                  type="password"
                  margin="normal"
                  label="Contraseña"
                  className="kt-width-full"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  helperText={touched.password && errors.password}
                  error={Boolean(touched.password && errors.password)}
                />
              </div>

              <div className="form-group">
                <TextField
                  type="password"
                  margin="normal"
                  label="Confirmación de contraseña"
                  className="kt-width-full"
                  name="confirmPassword"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.confirmPassword}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  error={Boolean(
                    touched.confirmPassword && errors.confirmPassword
                  )}
                />
              </div>


              <div className="kt-login__actions">
                <Link
                  to="/auth/forgot-password"
                  className="kt-link kt-login__link-forgot"
                >
                  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                </Link>

                <Link to="/auth">
                  <button type="button" className="btn btn-secondary btn-elevate kt-login__btn-secondary">
                    Regresar
                  </button>
                </Link>

                <button
                  disabled={isSubmitting || !values.acceptTerms}
                  className="btn btn-primary btn-elevate kt-login__btn-primary"
                >
                  Enviar
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Verification)
);
